export default "__VITE_ASSET__BktW8DPM__"